<template>
    <!-- 报警触发 -->
    <AlarmDialog
        ref="alarmDialog"
        :isAlarm.sync="alarmShow"
        :title="title"
        :loading="loading"
        :tableData="tableData"
        :choozeTable="triggerList"
        :total="total"
        :detailObj="{ sceneId: scene }"
        :disabledLoad="disabledLoad"
        v-on="$listeners"
        v-if="scene"
    />
</template>

<script>
import AlarmDialog from '@/pages/business/components/dialog/AlarmDialog.vue';
import { alarmTriggerList, getCarrierAlarmTrigger } from '@/api/modules/alarm.js';
export default {
    // 需提供是否展示,以及scene(架构id)
    props: ['show', 'scene', 'carrierId', 'triggerList'],
    components: {
        AlarmDialog
    },
    watch: {
        show() {
            if (this.show) {
                this.dioForm.iDisplayStart = 0;
                this.dioForm.iDisplayLength = 15;
                this.getListFn();
            } else {
                this.disabledLoad = false;
                this.tableData = [];
            }
        }
    },
    data() {
        return {
            title: $t('integration.trigger_settings'),
            tableData: [],
            loading: false,
            total: 0,
            disabledLoad: false,
            dioForm: {
                iDisplayStart: 0,
                iDisplayLength: 15,
                name: '',
                scopeId: ''
            }
        };
    },
    computed: {
        alarmShow: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        }
    },
    methods: {
        getListFn() {
            if (this.disabledLoad) {
                return;
            }
            this.loading = true;
            this.dioForm.scopeId = this.scene;
            alarmTriggerList(this.dioForm)
                .then(({ result, pageInfo }) => {
                    if (result.length > 0) {
                        result.forEach(item => {
                            this.tableData.push(item);
                        });
                        //this.tableData = this.tableData.concat(result);
                    } else {
                        this.tableData = result;
                    }
                    this.total = pageInfo.total;
                    if (this.tableData.length >= this.total) {
                        this.disabledLoad = true;
                    }
                })
                .then(() => {
                    if (this.carrierId) {
                        getCarrierAlarmTrigger({ carrierId: this.carrierId }).then(({ result }) => {
                            this.choozeTable = this.choozeTable.concat(result);
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
